export default __webpack_public_path__ + "dfb6fd93d70c0e4626cfb8f483ba11b4.png";